export const actionTypePrefix = '@@simpleXHR';
export const reduxKey = '@@simpleXHR';
export var SimpleXHRMethod = /*#__PURE__*/ function(SimpleXHRMethod) {
    SimpleXHRMethod["GET"] = "get";
    SimpleXHRMethod["POST"] = "post";
    return SimpleXHRMethod;
}({});
export var SimpleXHREndpoint = /*#__PURE__*/ function(SimpleXHREndpoint) {
    SimpleXHREndpoint["GIVE_POINTS"] = "/points_modal/give";
    SimpleXHREndpoint["GIVE_POINTS_POPUP"] = "/points_modal";
    SimpleXHREndpoint["GIVE_LLAMA"] = "/give_llama";
    SimpleXHREndpoint["GIVE_BADGE"] = "/corebadge/award";
    SimpleXHREndpoint["INIT_DEVIATION"] = "/init";
    SimpleXHREndpoint["SELLER_DISCOUNT_CREATE"] = "/discounts/create";
    return SimpleXHREndpoint;
}({});

//# sourceMappingURL=constants.js.map